import React, { useEffect, useState, useRef } from 'react'
import { Button } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal'
//Icons 
import { FaCcVisa, FaPhoneAlt } from 'react-icons/fa';
//Utils
import { RenderIf } from '../../../utils/RenderIf';



function ModalPhoneSaveYappy({ showModalPhone, setShowModalPhone, nextStepYappy, phone }) {

  //Ref for yappy button
  const yappyBtnRef = useRef(null);
  //Refs
  const phoneClientYappy = useRef(null);

  // Set the input value when phone prop changes
  useEffect(() => {
    if (phoneClientYappy?.current) {
      phoneClientYappy.current.value = phone || '';
    }
  }, [phone, showModalPhone]);

  //Use effect to handle the Yappy button events
  useEffect(() => {
    const btnYappy = yappyBtnRef.current;
    const phoneClient = phoneClientYappy.current;
    console.log("btnYappy", btnYappy)

    //We check the yappy button 
    if (btnYappy !== null && btnYappy !== undefined && phoneClient !== null && phoneClient !== undefined) {

      //This is for the event yappy btn success
      btnYappy.addEventListener("eventSuccess", (e) => {
        //setShowModalPhone(false); // Cierra el modal
        console.log("Transaccion ejecutada", e.detail);
        nextStepYappy(btnYappy, phoneClient.value, "success", e.detail);
      });

      //This is for the event yappy btn error
      btnYappy.addEventListener("eventError", (e) => {
        console.log("Transaccion no ejecutada", e.detail)
        nextStepYappy(btnYappy, phoneClient.value, e.detail, 0);
      });

      //This is for the event of the click 
      btnYappy.addEventListener("eventClick", async (e) => {
        nextStepYappy(btnYappy, phoneClient.value, "create", 0);
      });

      btnYappy.addEventListener("eventPayment", (e) => {
        console.log("event payment", e)
      })
    }

    console.log("yappy phone", phone);

  }, [showModalPhone])



  return (
    <>

      {/*input phone client */}
  

      <Modal
        id="modal-phone-yappy"
        show={showModalPhone}
        fullscreen
        onHide={() => setShowModalPhone(false)}
        aria-labelledby="example-custom-modal-styling-title"
        centered
        contentClassName="sp-yap-content"
      >
        <Modal.Body className="sp-yap">
          <div className="sp-yap__card">

            {/* Header */}
            <div className="sp-yap__head">
              {/* <div className="sp-yap__badge"><i className="uil uil-phone"></i></div> */}
              <div className="sp-yap__headinfo">
                <span className="sp-yap__eyebrow">Método de pago</span>
                <h4 className="sp-yap__title">Yappy</h4>
              </div>
              <button className="sp-yap__x" type="button" aria-label="Cerrar" onClick={() => setShowModalPhone(false)}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
              </button>
            </div>

            {/* Input */}
            <div className="sp-yap__field">
              <label className="sp-yap__label"><i className="uil uil-phone-volume"></i> Ingrese número de teléfono</label>
              <div className="sp-yap__inputwrap">
                <input
                  type="text"
                  className="sp-yap__input"
                  defaultValue={phone || ''}
                  ref={phoneClientYappy}
                  placeholder="6000-0000"
                />
              </div>
            </div>

            {/* Footer */}
            <div className="sp-yap__foot">
              <button className="sp-yap__btn sp-yap__btn--cancel" onClick={() => setShowModalPhone(false)}>Cancelar</button>
              <RenderIf isTrue={showModalPhone !== false}>
                <div className="sp-yap__yappywrap">
                  <btn-yappy
                    theme="blue"
                    id={`yappy-btn`}
                    ref={yappyBtnRef}
                    className="btn btn-lg"
                    phone={"66425118"}
                  ></btn-yappy>
                </div>
              </RenderIf>
            </div>

          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default ModalPhoneSaveYappy